// extracted by mini-css-extract-plugin
module.exports = {"socialWrap":"__5xlg8X7k","logo":"q_XIMBqC","social":"wd7B6YrD","item":"ca_tP9E2","imgWrap":"iHPWfQ9a","qrWrap":"__6JWuqEBs","icon":"Fe9h7MuO"};